module.exports = __webpack_public_path__ + "static/media/muy-buena.9f25efcf.svg";